import request from 'manager/utils/request';
import { REST_SERVICE } from '@manager/config';

const statisticService = {
  //登记类型 业务统计表
  statisticsNew (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.registerTypeStatistic,
      method: 'post',
      params,
    });
  },
  statisticsNewwlmqs (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.registerTypeStatisticwlmqs,
      method: 'post',
      params,
    });
  },
  //银行业务统计
  getQlxxCountForYh (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.getQlxxCountForYh,
      method: 'post',
      params,
    });
  },
  //登记类型 业务统计 树表
  statisticsTree (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.registerTypeStatisticTree,
      method: 'get',
      params,
    });
  },
  //推送状态 业务统计 表
  pushState (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.pushState,
      method: 'post',
      params,
    });
  },
  //推送状态 业务统计 表
  pushStatewlmqs (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.pushStatewlmqs,
      method: 'post',
      params,
    });
  },
  //推送状态 业务统计 树表
  pushStateTree (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.pushStateTree,
      method: 'get',
      params,
    });
  },

  //业务状态 业务统计 表
  servicesState (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.servicesState,
      method: 'post',
      params,
    });
  },
  //业务状态 业务统计 表
  servicesStatewlmqs (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.servicesStatewlmqs,
      method: 'post',
      params,
    });
  },

  //业务状态 业务统计 表
  servicesStateTree (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.servicesStateTree,
      method: 'get',
      params,
    });
  },

  //跨省通办 业务统计 表
  getKstbQlxxCountByYwlx (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.getKstbQlxxCountByYwlx,
      method: 'post',
      params,
    });
  },

  //跨省通办 业务统计 表
  getKstbQlxxCountByYwlxwlmqs (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.getKstbQlxxCountByYwlxwlmqs,
      method: 'post',
      params,
    });
  },

  //按申请人类型 业务统计
  getKstbQlxxCountBySqrlx (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.getKstbQlxxCountBySqrlx,
      method: 'post',
      params,
    });
  },
  // 公积金一件事查询
  gjjOneThing (params) {
    return request({
      url: REST_SERVICE.serviceStatistics.getGjjOneThing,
      method: 'post',
      params,
    });
  },
};

export default statisticService;
